// extracted by mini-css-extract-plugin
export default {"EditProfile":"EditProfile_EditProfile__MKVC0"};